// Constants for Lob's 4x6 postcard (https://www.lob.com/docs#postcards)
export const CARD_WIDTH = '6.25in'; // 6.25" full bleed width
export const CARD_HEIGHT = '4.25in'; // 4.25" full bleed height
export const SAFE_WIDTH = '5.875in'; // 5.875" safe area width
export const SAFE_HEIGHT = '3.875in'; // 3.875" safe area height
export const SAFE_MARGIN = '0.1875in'; // 0.1875" safe margin (bleed area)

// For preview rendering (numeric values without units)
export const CARD_WIDTH_NUM = 6.25; 
export const CARD_HEIGHT_NUM = 4.25;
export const SAFE_WIDTH_NUM = 5.875;
export const SAFE_HEIGHT_NUM = 3.875;
export const BLEED = 0.125;
export const PPI = 300; // pixels per inch for print quality

// Calculated pixel dimensions
export const CARD_WIDTH_PX = CARD_WIDTH_NUM * PPI; // 1875px
export const CARD_HEIGHT_PX = CARD_HEIGHT_NUM * PPI; // 1275px
export const SAFE_WIDTH_PX = SAFE_WIDTH_NUM * PPI; // 1762.5px
export const SAFE_HEIGHT_PX = SAFE_HEIGHT_NUM * PPI; // 1162.5px
export const BLEED_PX = BLEED * PPI; // 37.5px

// Brand colors (matching tailwind.config.js)
export const PRIMARY_COLOR = '#FA775A'; // brand-primary
export const SECONDARY_COLOR = '#4A4A4A'; // brand-secondary
export const ACCENT_COLOR = '#FFD8CC'; // brand-accent

// Inline SVG logo with Mail icon
export const CARDIBLE_LOGO_SVG = `<svg width="120" height="40" xmlns="http://www.w3.org/2000/svg">
  <!-- Mail Icon -->
  <svg x="5" y="5" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z" 
      fill="${PRIMARY_COLOR}" />
  </svg>
  
  <!-- Cardible Text -->
  <text 
    x="34" 
    y="24" 
    font-family="Poppins, Arial, sans-serif" 
    font-size="16" 
    font-weight="bold" 
    fill="${SECONDARY_COLOR}"
  >
    Cardible
  </text>
</svg>`; 